import { FC } from 'react';
import { useParams } from 'react-router-dom';
import PageContainer from 'components/PageContainer';
import PageContent from 'components/PageContent';
import PageSection from 'components/PageSection';
import { useLayoutContext } from 'contexts/LayoutContext';
import api from 'lib/trpcClient';
import Spacing from 'components/Spacing';
import { Typography } from '@mui/material';
import { numberToCurrencyString } from 'further-ui/utils';
import FieldRow from 'components/FormElements/FieldRow';
import RecordView from 'components/RecordView';

const UnrealisedFXGainOrLossSubTypeLabels = {
  FXGainPayable: 'FX Gain (Payable)',
  FXLossPayable: 'FX Loss (Payable)',
  FXGainReceivable: 'FX Gain (Receivable)',
  FXLossReceivable: 'FX Loss (Receivable)',
};

const PayablesOrReceivablesHistoryDetail: FC = () => {
  const { recordId } = useParams<{ recordId: string }>();
  const { vehicle } = useLayoutContext();

  const { data: record, isLoading } =
    api.unrealisedFxGainOrLoss.getById.useQuery({
      vehicleId: vehicle?._id ?? '',
      recordId,
    });

  if (isLoading || !vehicle) {
    return null;
  }

  if (!record) {
    return (
      <PageContainer>
        <PageContent>
          <PageSection>
            <p>Record not found</p>
          </PageSection>
        </PageContent>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <PageContent>
        <Spacing>
          <PageSection title="Unrealised FX Gain/Loss Details" withSpacing>
            <RecordView>
              <FieldRow title="Date">
                <Typography variant="body2">
                  {record.ledgerDate.toLabel()}
                </Typography>
              </FieldRow>
              <FieldRow title="Counterparty">
                <Typography variant="body2">
                  {record.counterpartyLabel ?? '-'}
                </Typography>
              </FieldRow>
              <FieldRow title="Type">
                <Typography variant="body2">
                  {
                    UnrealisedFXGainOrLossSubTypeLabels[
                      record.gainOrLossSubType
                    ]
                  }
                </Typography>
              </FieldRow>
              <FieldRow title="Amount (LCY)">
                <Typography variant="body2">
                  {numberToCurrencyString(record.amountLcy, {
                    fallback: '-',
                    currency: vehicle.baseCurrency,
                    negativeInBrackets: true,
                  })}
                </Typography>
              </FieldRow>
              <FieldRow title="Currency">
                <Typography variant="body2">{record.currencyCode}</Typography>
              </FieldRow>
            </RecordView>
          </PageSection>
        </Spacing>
      </PageContent>
    </PageContainer>
  );
};

export default PayablesOrReceivablesHistoryDetail;
